<div *ngIf="visible" #ctaRoot class="rewarded-ad-cta">
    <button type="button" class="rewarded-ad-cta__button" [disabled]="loading" (click)="startRewardedAd()">
        <ng-container *ngIf="!loading">
            <mat-icon class="rewarded-ad-cta__icon">smart_display</mat-icon>
            <span class="rewarded-ad-cta__label" i18n="@@rewardedAdOfferCta">Hide ads for 1 hour — watch a short video</span>
        </ng-container>
        <ng-container *ngIf="loading">
            <span class="rewarded-ad-cta__spinner" aria-hidden="true"></span>
            <span class="rewarded-ad-cta__label" i18n="@@rewardedAdLoading">Loading ad…</span>
        </ng-container>
    </button>
</div>
